// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XXdG","clinicsSelect":"styles_clinicsSelect__1JXz5"};